import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobContactActions'
import { getAllContacts, fetchContactGroupsByJobId } from '../contactsSaga'
import * as api from '../../api/job/contacts'

function* jobContactsRefresh(action) {
  try {
    const payload = yield call(api.getJobContacts, action.jobId)
    yield put({ type: constants.JOB_CONTACTS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_CONTACTS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobContacts() {
  yield takeLatest(constants.JOB_CONTACTS_REFRESH.ACTION, jobContactsRefresh)
}

function* sagaCreateJobContact(action) {
  try {
    const payload = {
      job_id: action.jobId,
      content: action.content,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createContact, payload)
    yield put({ type: constants.CREATE_JOB_CONTACT.SUCCESS, payload })
    yield call(getAllContacts)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_JOB_CONTACT.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobContact() {
  yield takeLatest(constants.CREATE_JOB_CONTACT.ACTION, sagaCreateJobContact)
}

function* sagaAddJobContact(action) {
  try {
    const payload = {
      job_id: action.jobId,
      content: action.content,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.addJobContact, payload)
    yield put({ type: constants.ADD_JOB_CONTACT.SUCCESS, payload })
    yield call(jobContactsRefresh, action)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ADD_JOB_CONTACT.FAILED,
      message: e.message || e
    })
  }
}

function* watchAddJobContact() {
  yield takeLatest(constants.ADD_JOB_CONTACT.ACTION, sagaAddJobContact)
}

function* sagaRemoveJobContact(action) {
  try {
    const payload = {
      contact_id: action.contactId
    }
    yield call(api.removeJobContact, payload)
    yield put({ type: constants.REMOVE_JOB_CONTACT.SUCCESS, payload })
    yield call(jobContactsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.REMOVE_JOB_CONTACT.FAILED,
      message: e.message || e
    })
  }
}

function* watchRemoveJobContact() {
  yield takeLatest(constants.REMOVE_JOB_CONTACT.ACTION, sagaRemoveJobContact)
}

function* sagaUpdateJobContact(action) {
  try {
    const payload = {
      contact_data: {
        primary_contact: action.content
      },
      job_id: action.jobId,
      contact_id: action.contactId,
      updated_by_id: action.userId
    }
    yield call(api.updateJobContact, payload)
    yield put({ type: constants.JOB_CONTACT_UPDATE.SUCCESS, payload })
    yield call(jobContactsRefresh, action)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_CONTACT_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobContact() {
  yield takeLatest(constants.JOB_CONTACT_UPDATE.ACTION, sagaUpdateJobContact)
}

function* sagaDeleteJobContact(action) {
  try {
    const payload = {
      attachment_id: action.attachmentId
    }
    yield call(api.deleteJobContact, payload)
    yield put({ type: constants.JOB_CONTACT_DELETE.SUCCESS, payload })
    yield call(jobContactsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_CONTACT_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobContact() {
  yield takeLatest(constants.JOB_CONTACT_DELETE.ACTION, sagaDeleteJobContact)
}

function* sagaUpdateJobPrimaryContact(action) {
  try {
    const payload = {
      jobId: action.jobId,
      contactId: action.contactId
    }
    yield call(api.updateJobPrimaryContact, payload)
    yield put({ type: constants.UPDATE_JOB_PRIMARY_CONTACT.SUCCESS, payload })
    yield call(jobContactsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_JOB_PRIMARY_CONTACT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobPrimaryContact() {
  yield takeLatest(constants.UPDATE_JOB_PRIMARY_CONTACT.ACTION, sagaUpdateJobPrimaryContact)
}

function* sagaCreateJobContactGroup(action) {
  try {
    const payload = {
      jobId: action.jobId,
      userId: action.userId
    }
    yield call(api.createJobContactGroup, payload)
    yield put({ type: constants.CREATE_JOB_CONTACT_GROUP.SUCCESS, payload })
    yield call(fetchContactGroupsByJobId, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_JOB_CONTACT_GROUP.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobContactGroup() {
  yield takeLatest(constants.CREATE_JOB_CONTACT_GROUP.ACTION, sagaCreateJobContactGroup)
}

function* sagaDeleteContactGroup(action) {
  try {
    const payload = {
      groupId: action.groupId
    }
    yield call(api.removeJobContactGroup, payload)
    yield put({ type: constants.DELETE_JOB_CONTACT_GROUP.SUCCESS, payload })
    yield call(fetchContactGroupsByJobId, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_JOB_CONTACT_GROUP.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobContact() {
  yield takeLatest(constants.DELETE_JOB_CONTACT_GROUP.ACTION, sagaDeleteContactGroup)
}

function* sagaUpdateJobContactGroup(action) {
  try {
    const payload = {
      groupId: action.groupId,
      name: action.name
    }
    yield call(api.updateJobContactGroup, payload)
    yield put({ type: constants.UPDATE_JOB_CONTACT_GROUP.SUCCESS, payload })
    yield call(fetchContactGroupsByJobId, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_JOB_CONTACT_GROUP.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobContactGroup() {
  yield takeLatest(constants.UPDATE_JOB_CONTACT_GROUP.ACTION, sagaUpdateJobContactGroup)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobContacts),
    fork(watchAddJobContact),
    fork(watchRemoveJobContact),

    fork(watchCreateJobContact),
    fork(watchUpdateJobContact),
    fork(watchDeleteJobContact),

    fork(watchCreateJobContactGroup),
    fork(watchUpdateJobContactGroup),
    fork(watchDeleteJobContact),

    fork(watchUpdateJobPrimaryContact)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobContactSaga.js